<div (click)="selecionarImagem()"></div>
